import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';
import './index.less';
import Modal from '../modal/index';
import showImg from '../../../../assets/images/screen-recorder-bestimg-test.png'; //recorder
import VideoConverter from '../../../../assets/images/convertpic.png'; //convter
import winImg from '../../../../assets/icons/screen-recorder-win.svg'; //windows
import VideoEditor from '../../../../assets/images/video-editor.png'; //editor
import MacImg from '../../../../assets/icons/mac-icon.svg';
import { useTranslation } from 'react-i18next';
import Utils from '../../../../utils';
import sendGaEvent from '@/ga';
export default function ModalByBest(props) {
  const { t } = useTranslation('screenRecorder');

  const { type = 'converter', isOpenDesk, closeModal } = props; //type == converter editor recorder
  // modal部分

  const close = () => {
    if (type == 'screen') {
      sendGaEvent({
        category: 'record',
        action: 'ScreenRecorder_MoreRecordingOptionsClose',
      });
    }
    closeModal();
  };
  const converterData = [
    { content: t('CovertAudioFormats') },
    { content: t('DownloadVideoFromWebsites') },
    { content: t('BatchConvertImageAndGif') },
    { content: t('RichEdingingFeatures') },
  ];

  const editorData = [
    { content: t('MakeSimpleEdits') },
    { content: t('BeyondImaginationMaterials') },
    { content: t('AqualityVideoMaker') },
    { content: t('WorkOnAnywhere') },
  ];

  const screenRecorderData = [
    { content: t('CaptureAnythingOnScreen') },
    { content: t('RecordToShare') },
    { content: t('StreamOnFackbook') },
    { content: t('BringMagic') },
  ];

  const downloadDesk = () => {
    window.onbeforeunload = function () {};
    if (type === 'screen') {
      window.location.href = Utils.getHitPawVideoScreenLink();
      sendGaEvent({
        category: 'record',
        action: 'ScreenRecorder_MoreRecordingOptionsDownload',
      });
    } else if (type === 'converter') {
      window.location.href = Utils.getHitPawConvertLink();
    } else if (type === 'editor') {
      window.location.href = Utils.getHitPawVideoEditorEXELink();
    }
    window.onbeforeunload = () => {
      return 'close';
    };
    // window.location.href = Utils.getHitPawConvertLink()   getHitPawVideoScreenLink()  getHitPawVideoEditorBuyLink()
  };

  return (
    <Modal open={isOpenDesk} close={close}>
      <div className='modal-by-best'>
        <div className='contentBody'>
          <div className='article'>
            <div className='topTitle'>
              {type === 'converter'
                ? t('120XDownload')
                : type === 'editor'
                ? t('BestVideoEditor')
                : t('BestScreenRecorderSoftware')}
            </div>
            {type === 'converter'
              ? converterData.map((item, value) => {
                  return (
                    <div key={'convertList' + value} className='sub'>
                      <i className='spot'></i>
                      <div className='substance'>{item.content}</div>
                    </div>
                  );
                })
              : type === 'editor'
              ? editorData.map((item, value) => {
                  return (
                    <div key={'editorList' + value} className='sub'>
                      <i className='spot'></i>
                      <div className='substance'>{item.content}</div>
                    </div>
                  );
                })
              : screenRecorderData.map((item, value) => {
                  return (
                    <div key={'screenRecorderDataList' + value} className='sub'>
                      <i className='spot'></i>
                      <div className='substance'>{item.content}</div>
                    </div>
                  );
                })}
            <div className='download' onClick={() => downloadDesk()}>
              <img
                src={Utils.getSystemType() === 'Windows' ? winImg : MacImg}
                alt=''
              />
              <span className='words'>{t('TryItFree')}</span>
            </div>
          </div>
          <img
            className='prodImg'
            src={
              type === 'converter'
                ? VideoConverter
                : type === 'editor'
                ? VideoEditor
                : showImg
            }
            alt=''
          />
        </div>
      </div>
    </Modal>
  );
}
